// extracted by mini-css-extract-plugin
module.exports = {"arrow":"arrow__IveJk","inactive":"inactive__1zaha","forward":"forward__1oNxv","hidden":"hidden__1CPq-"};